import "./styles/yellow-separator.css";
const YellowSeparator = () => {
  return <div className="doted-separator"></div>;
};

export default YellowSeparator;
